<template>
  <div>
    <div class="page-header clear-filter">
      <parallax
        v-bind:useScroll="false"
        class="page-header-image"
        style="background-image:url('/img/img_account.png')"
      ></parallax>
      <div class="container" id="top">
        <div
          style="position: absolute; width: 100%; height: 762px; left: 0px; top: 80px; background-color: white;"
        >
          <div
            style="position: absolute; left: 0px; top: 0px; height: 40px; width: 100%; display: flex;"
          >
            <div
              v-for="(tab, index) in tabs"
              v-bind:key="index"
              v-bind:class="{'tab_active': tabIdx == index, 'tab_inactive': tabIdx != index}"
              style="height: 40px; position: relative; width: calc(33%);"
              @click="goTab(index)"
            >
              <div style="text-align: left;">
                <div
                  style="
                        font-size: 11px;
                        font-weight: 600;
                        text-align: center;
                        padding: 5px;
                        "
                >{{$t(`${tab.name}`)}}</div>
              </div>
              <div
                v-if="tabIdx == index"
                style="width: 100%; height: 3px; background-image: url('/img/line_1.png'); position: absolute; left: 0px; top: 40px;"
              ></div>
            </div>
            <!-- <div
              style="position: absolute; bottom: 0px; left: 0px; width: 100%; padding-bottom: 20px; cursor: pointer;"
            >
              <div
                @click="signout()"
                style="text-align: center; font-size: 1.2em;
                        font-weight: 600;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal;
                        text-decoration: underline;
                        color: #999999;"
              >{{$t(`account_signout`)}}</div>
            </div> -->
          </div>
          <div
            v-if="tabIdx == 0"
            style="position: absolute; left: 00px; top: 60px; width: calc(100%); height: 100%;"
          >
            <div style="text-align: left; position: absolute; left: 10px; top: 0px;">
              <div
                style="font-size: 18px; font-weight: 900; color: #8400ff;"
              >{{$t(`account_balance`)}} : {{myBalance.toFixed(6)}} ETH</div>
            </div>
            <div style="text-align: left; position: absolute; left: 0px; top: 40px; width: 100%;">
              <div
                style="font-size: 14px; font-weight: 600; color: #000000; position: absolute; left: 0px; top: 0px; width: 100%; padding-left: 10px;"
              >{{$t(`account_publickey`)}} : {{myAddress}}</div>
            </div>
            <div style="text-align: left; position: absolute; left: 0px; top: 90px; width: 100%;">
              <div
                style="font-size: 18px; font-weight: 600; color: #000000; top: 0px; width: 100%; margin: auto; text-align: center;"
              >{{$t(`Unclaimd Reward`)}} : {{unclaimed.toFixed(4)}} DAI</div>
            </div>
            <div style="position: absolute; left: 0px; top: 120px; width: 100%; text-align: center; ">
              <div @click="claimRewardPop()" style="cursor: pointer; text-align: center; background-image: url('/img/btn_180.png'); background-size: 100% 100%; width: 120px; height: 40px; font-size: 16px; color: #fff568; font-weight: 600; margin: auto; padding-top: 6px;">
                {{$t('Claim all')}}
                </div>
            </div>
            <div style="position: absolute; left: 0px; top: 160px; width: 100%; text-align: center; ">
              <div @click="syncMyLands()" style="cursor: pointer; text-align: center; background-image: url('/img/btn_180.png'); background-size: 100% 100%; width: 120px; height: 40px; font-size: 16px; color: #fff568; font-weight: 600; margin: auto; padding-top: 6px;">
                {{$t('account_myland')}}
                </div>
            </div>
            <div v-if="myLandIds.length > 0"
              style="position: absolute; left: 0px; top: 200px; width: 100%; height: 597px; overflow-y: auto;"
              class="scrollbox"
            >
              <div
                @click="goToSee(myLandId)"
                v-for="(myLandId, index) in myLandIds"
                v-bind:key="index"
                v-bind:style="{position: 'absolute', left: `calc((100% - 322px)/2)`, top: `${10 + index * 266}px`, width: '322px', height: '256px', 'background-image': `url('/img/bg_land_sell.png')`, cursor: 'pointer'}"
              >
                <img
                  v-bind:src="getLandCardUrl(myLandId)"
                  width="322px"
                  style="position: absolute; left: 0px; top: 0px;"
                />
                <div
                  style="position: absolute; bottom: 5px; left: calc((100% - 180px) / 2); background-image: url('/img/btn_180.png'); background-size: 100% 100%; width: 180px; height: 48px; font-size: 18px; color: #fff568; font-weight: 600; padding-top: 10px;"
                >{{$t('go_to_see')}}</div>
              </div>
            </div>
            <div v-if="myLandIds.length == 0" style="text-align: center; margin-top: 310px; width: 100%;">
              <div
                style="
                    font-size: 30px;
                    font-weight: 900;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    color: #000000;
                    "
              >{{$t(`account_myland_nolands`)}}</div>
            </div>
          </div>
         <div
            v-if="tabIdx == 1"
            style="position: absolute; left: 0px; top: 60px; width: 100%; height: 752px;"
          >
            <div
              style="position: absolute; left: 0px; top: 0px; width: 100%; height: 700px; overflow-y: auto;"
              class="scrollbox"
            >
               <div style="position: absolute; left: 0px; top: 0px;">
                <div v-bind:style="{height: '52px', width: '100%', display: 'flex', 'background-image': `url('/img/table_sale_history_top.png')`}">
                  <div
                    style="position: relative; width: 90px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{$t('head_status')}}
                  <img src="/img/table_sale_history_line1.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>
                  <div
                    style="position: relative; width: 109px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{$t('Amount')}}
                  <img src="/img/table_sale_history_line1.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>                  
                  <div
                    style="position: relative; width: 158px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{$t('head_time')}}
                  <img src="/img/table_sale_history_line1.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>
                  <div
                    style="position: relative; width: 239px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{$t('head_txHash')}}</div>
                </div>
              </div>
              <div style="position: absolute; left: 0px; top: 52px;">
                <div v-for="(log, index) in claimHistory" v-bind:key="index" v-bind:style="{height: '50px', width: '100%', display: 'flex', 'background-image': `url('/img/table_sale_history_info${(index % 2)+1}.png')`}">
                  <div
                    style="position: relative; width: 90px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{$t(`task_status_${log.status}`)}}
                  <img src="/img/table_sale_history_line2.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>
                  <div
                    style="position: relative; width: 109px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{log.finalReward.toFixed(4)}} DAI
                  <img src="/img/table_sale_history_line2.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>
                  <div
                    style="position: relative; width: 158px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{log.claimDate | date}}
                  <img src="/img/table_sale_history_line2.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>
                  <div v-if="log.status == 'confirmed' || log.status == 'tx'"
                    style="position: relative; width: 239px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  ><span class="ellipsis">{{log.txHash}}</span> <a class="ellipsis" v-bind:href="getEtherScanUrl(log.txHash)" target="_blank">[etherscan]</a></div>
                  <div v-else
                    style="position: relative; width: 239px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="tabIdx == 2"
            style="position: absolute; left: 0px; top: 60px; width: 100%; height: 752px;"
          >
            <div
              style="position: absolute; left: 0px; top: 0px; width: 100%; height: 700px; overflow-y: auto;"
              class="scrollbox"
            >
               <div style="position: absolute; left: 0px; top: 0px;">
                <div v-bind:style="{height: '52px', width: '100%', display: 'flex', 'background-image': `url('/img/table_sale_history_top.png')`}">
                  <div
                    style="position: relative; width: 80px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{$t('head_landId')}}
                  <img src="/img/table_sale_history_line1.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>
                  <div
                    style="position: relative; width: 90px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{$t('head_status')}}
                  <img src="/img/table_sale_history_line1.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>
                  <div
                    style="position: relative; width: 109px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{$t('head_amount')}}
                  <img src="/img/table_sale_history_line1.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>                  
                  <div
                    style="position: relative; width: 158px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{$t('head_time')}}
                  <img src="/img/table_sale_history_line1.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>
                  <div
                    style="position: relative; width: 239px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{$t('head_txHash')}}</div>
                </div>
              </div>
              <div style="position: absolute; left: 0px; top: 52px;">
                <div v-for="(log, index) in presaleHistory" v-bind:key="index" v-bind:style="{height: '50px', width: '100%', display: 'flex', 'background-image': `url('/img/table_sale_history_info${(index % 2)+1}.png')`}">
                  <div @click="goToSee(log.landId)"
                    style="position: relative; width: 80px; height: 100%; font-size: 16px; color: #0000ff; font-weight: 300; margin: auto; padding-top: 12px; cursor: pointer;"
                  >#{{log.landId}}
                  <img src="/img/table_sale_history_line2.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>
                  <div
                    style="position: relative; width: 90px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{$t(`task_status_${log.status}`)}}
                  <img src="/img/table_sale_history_line2.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>
                  <div v-if="log.code == 'use_coupon'"
                    style="position: relative; width: 109px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{$t('use_coupon')}}
                  <img src="/img/table_sale_history_line2.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>
                  <div v-if="log.code == 'buy_presale_land' && log.price != null"
                    style="position: relative; width: 109px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{log.price.toFixed(4)}} ETH
                  <img src="/img/table_sale_history_line2.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>
                  <div v-if="log.code == 'buy_presale_land' && log.price == null"
                    style="position: relative; width: 109px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >0 ETH
                  <img src="/img/table_sale_history_line2.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>
                  <div
                    style="position: relative; width: 158px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  >{{log.logDate | date}}
                  <img src="/img/table_sale_history_line2.png" style="position: absolute; right: 1px; top: 0px;" height="48px">
                  </div>
                  <div
                    style="position: relative; width: 239px; height: 100%; font-size: 16px; color: black; font-weight: 300; margin: auto; padding-top: 12px;"
                  ><span class="ellipsis">{{log.txHash}}</span> <a class="ellipsis" v-bind:href="getEtherScanUrl(log.txHash)" target="_blank">[etherscan]</a></div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div
            v-if="tabIdx == 3"
            style="position: absolute; left: 280px; top: 0px; width: calc(100% - 280px); height: 100%;"
          >
            <div style="text-align: center; margin-top: 210px; width: 100%;">
              <div
                style="
                    font-size: 30px;
                    font-weight: 900;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    color: #000000;
                    "
              >{{$t(`Coming Soon!!`)}}</div>
            </div>
          </div> -->
          <div
            v-if="tabIdx == 3"
            style="position: absolute; left: 0px; top: 60px; width: 100%; height: 100%;"
          >
            <div style="text-align: left; position: absolute; left: 10px; top: 0px;">
              <div
                style="font-size: 18px; font-weight: 900; color: #8400ff;"
              >{{$t(`account_balance`)}} : {{myBalance.toFixed(6)}} ETH</div>
            </div>
            <div style="text-align: left; position: absolute; left: 0px; top: 40px; width: 100%;">
              <div
                style="font-size: 14px; font-weight: 600; color: #000000; position: absolute; left: 0px; top: 0px; width: 100%; padding-left: 10px;"
              >{{$t(`account_publickey`)}} : {{myAddress}}</div>
            </div>
            <div style="text-align: left; position: absolute; left: 0px; top: 100px; width: 100%;">
              <div
                style="font-size: 14px; font-weight: 600; color: #000000; position: absolute; left: 0px; top: 0px; width: 100%; padding-left: 10px;"
              >{{$t(`recommend_url`)}} : {{myRefURL}}</div>
            </div>
            <div style="text-align: left; position: absolute; left: 0px; top: 140px; width: 100%;">
              <div
                  style="width: 180px; height: 30px; cursor: pointer; background-image: url('/img/btn_180.png'); background-size: 100% 100%; font-size: 1.2em; position: absolute; left: 40px; top: 0px;
                  font-weight: 400;
                  text-align: center;
                  color: #fff568; padding-top: 2px;"
                  v-clipboard:copy="myRefURL"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >{{$t(`Copy`)}}</div>
            </div>
            <div style="text-align: left; position: absolute; left: 0px; top: 180px; width: 100%;">
              <div
                style="font-size: 14px; font-weight: 600; color: #000000; position: absolute; left: 0px; top: 0px; width: 100%; padding-left: 10px;"
              >{{$t(`recommend_bonus`)}} : {{myRefBonus | comma}}</div>
            </div>
            <div style="text-align: left; position: absolute; left: 0px; top: 220px; width: 100%;">
              <div
                style="font-size: 14px; font-weight: 600; color: #000000; position: absolute; left: 0px; top: 0px; width: 100%; padding-left: 10px;"
              >{{$t(`Authenticate Level`)}} : 1</div>
            </div>
            <div @click="openPopup('inputCoupon')" style="text-align: center; position: absolute; left: calc((100% - 260px) / 2); top: 270px; width: 260px; height: 60px; background-image: url('/img/btn_coupon.png'); background-size: 100% 100%; cursor: pointer;
            color: white; font-size: 20px; font-weight: 600; padding-top: 14px;">
              {{$t(`input_coupon`)}}
            </div>
            <div
              style="position: absolute; top: 340px; left: 0px; width: 100%; cursor: pointer;"
            >
              <div
                @click="signout()"
                style="text-align: center; font-size: 18px;
                        font-weight: 600;
                        text-decoration: underline;
                        color: #999999;"
              >{{$t(`account_signout`)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      style="position: fixed; left: 0px; top: 0px; width: 100%; height: 100%; background-color: #00000099; cursor: pointer; z-index: 900;"
      v-if="popups.inputCoupon || popups.landResult || popups.claimReward"
      @click="closeAllPopup()"
    ></div>
    <div
      v-if="popups.inputCoupon"
      style="position: fixed; top: calc((100% - 440px) / 2); left: 0px; padding-top: 32px; text-align: center; width: 100%; height: 340px; background-image: url('/img/1st_sale/pop_wallet.png'); background-size: 100% 100%; z-index: 10000;"
    >
      <div
        style="position: absolute; top: 28px; right: 30px; width: 40px; height: 40px; cursor: pointer;"
        @click="closePopup('inputCoupon')"
      >
        <img src="/img/event/btn_close.png" />
      </div>
      <h5 style="color: white; font-size: 24px; font-weight: 900;">{{$t('input_coupon')}}</h5>
      <div style="position: absolute; top: 120px; left: 39px; width: calc(100% - 78px); height: 107px;">
        <h5 style="color: red; font-size: 18px; font-weight: 600; height: 45px;">* {{$t('info_only_land')}}</h5>
        <input
              type="text"
              v-model="coupon"
              v-bind:placeholder="$t('please_input_coupon')"
              style="color: white; margin: 10px auto; background-color: transparent; border: none; width: calc(100% - 20px); height: 44px; padding-left: 20px; background-image: url('/img/event/bg_email_box.png'); background-size: 100% 100%;"
            />
        <div
              style="width: 180px; height: 48px; background-image: url('/img/btn_180.png'); font-size: 16px;
            font-weight: 600;
            text-align: center;
            color: #fff568; padding-top: 13px;"
              @click="inputCoupon()"
              class="btn"
            >{{$t('btn_input')}}
          </div>            
      </div>
    </div>
    <div
      v-if="popups.landResult"
      style="position: fixed; top: calc((100% - 440px) / 2); left: 0px; padding-top: 32px; text-align: center; width: 100%; height: 340px; background-image: url('/img/1st_sale/pop_wallet.png'); background-size: 100% 100%;  z-index: 10000;"
    >
      <div
        style="position: absolute; top: 28px; right: 30px; width: 40px; height: 40px; cursor: pointer;"
        @click="closePopup('landResult')"
      >
        <img src="/img/event/btn_close.png" />
      </div>
      <h5 style="color: white; font-size: 24px; font-weight: 900;">{{$t('title_congratulation')}}</h5>
      <div style="position: absolute; top: 90px; left: 0px; width: 100%; height: 107px; padding: 20px; text-align: center;">
        <h5>{{$t('info_land_coupon_success')}}</h5>
        <div
        @click="goTab(1)"
          style="position: absolute; top: 160px; left: calc((100% - 180px) / 2); background-image: url('/img/btn_180.png'); background-size: 100% 100%; width: 180px; height: 48px; font-size: 18px; color: #fff568; font-weight: 600; padding-top: 10px; cursor: pointer;"
        >{{$t('go_to_see')}}</div>
      </div>
    </div>
    <div
      v-if="popups.claimReward"
      style="position: fixed; top: calc((100% - 440px) / 2); left: 0px; padding-top: 32px; text-align: center; width: 100%; height: 340px; background-image: url('/img/1st_sale/pop_wallet.png'); background-size: 100% 100%;  z-index: 10000;"
    >
      <div
        style="position: absolute; top: 28px; right: 30px; width: 40px; height: 40px; cursor: pointer;"
        @click="closePopup('claimReward')"
      >
        <img src="/img/event/btn_close.png" />
      </div>
      <h5 style="color: white; font-size: 24px; font-weight: 900;">{{$t('Reward Claim')}}</h5>
      <div style="position: absolute; top: 90px; left: 0px; width: 100%; height: 107px; padding: 20px; text-align: center;">
        <h5>{{$t('Amount')}} : {{claim.amount.toFixed(4)}} DAI</h5>
        <h5>{{$t('Fee')}} : {{claim.fee}} DAI</h5>
        <h5>{{$t('Net Reward')}} : {{claim.net.toFixed(4)}} DAI</h5>
        <h6 style="color: red;">* {{$t('info_claim_reward')}}</h6>
        <div
        @click="claimRewardDAI()"
          style="position: absolute; top: 170px; left: 100px; background-image: url('/img/btn_180.png'); background-size: 100% 100%; width: 180px; height: 48px; font-size: 18px; color: #fff568; font-weight: 600; padding-top: 10px; cursor: pointer;"
        >{{$t('Claim')}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Parallax, Button } from "@/components";
import { Popover } from "element-ui";
import { disconnectWallet } from "../utils/wallet";
import config from "../config.js";
import axios from "axios";
import moment from "moment";

export default {
  name: "index",
  bodyClass: "index-page",
  components: {
    Parallax,
    [Button.name]: Button,
    [Popover.name]: Popover
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    date(val) {
      if (val) {
        return moment(String(val)).format("YYYY-MM-DD HH:mm");
      }
    }
  },
  methods: {
    onCopy: function() {
      alert(this.$t(`info_copied`));
    },
    onError: function() {},
    getEtherScanUrl: function(txHash) {
      return `${config.etherscan.tx}/${txHash}`;
    },
    goToSee: function(landId) {
      this.$router.push(`/map/${landId}`);
    },
    goTab: function(tabIdx) {
      console.log('goTab - ', tabIdx)
      this.closeAllPopup();
      this.$router.push(`/account/${tabIdx}`);
    },
    selectTab: async function(tabIdx) {
      this.tabIdx = tabIdx;
      if (tabIdx == 2) {
        await this.getPresaleHistory();
      }
      else if (tabIdx == 1) {
        await this.getClaimHistory();
      }
      else if (tabIdx == 0) {
        await this.getMyLands();
      }
    },
    signout: function() {
      disconnectWallet(this.$store);
      this.$router.replace("/home");
    },
    getMyLands: async function() {
      let ret = await axios.post(`${config.api.nft_url}/presale/land/my`, {
        address: this.myAddress
      });
      if (!ret.data.result) {
        return;
      }
      this.myLandIds = ret.data.landIds;
    },
    syncMyLands: async function() {
      if (this.myAddress == '' || this.myAddress == null) {
        return;
      }
      let ret = await axios.post(`${config.api.nft_url}/presale/land/my/sync`, {
        address: this.myAddress
      });
      if (!ret.data.result) {
        return;
      }
      this.myLandIds = ret.data.landIds;
    },
    getUnclaimedRewards: async function() {
    let ret = await axios.post(`${config.api.nft_url}/landlord/reward/info`, {
        address: this.myAddress
      });
      if (!ret.data.result) {
        return;
      }
      this.unclaimed = ret.data.unclaimedToken;
    },
    getLandCardUrl(landId) {
      return `${config.card.url}/${landId}`;
    },
    getPresaleHistory: async function() {
      let ret = await axios.post(`${config.api.nft_url}/presale/history`, {
        address: this.myAddress
      });
      if (!ret.data.result) {
        return;
      }
      this.presaleHistory = ret.data.history;
      let existRun = false;
      for (let i = 0; i < this.presaleHistory.length; ++i) {
        let log = this.presaleHistory[i];
        if (log.status == 1) {
          existRun = true;
          break;
        }
      }
      if (existRun) {
        setTimeout(async () => {
          await this.getPresaleHistory();
        }, 3 * 1000);
      }
    },
    getClaimHistory: async function() {
      let ret = await axios.post(`${config.api.game_url}/land/reward/claim/list`, {
        publicKey: this.myAddress
      });
      if (!ret.data.result) {
        return;
      }
      this.claimHistory = ret.data.logs;
      let existRun = false;
      for (let i = 0; i < this.claimHistory.length; ++i) {
        let log = this.claimHistory[i];
        if (log.status != 'confirmed') {
          existRun = true;
          break;
        }
      }
      if (existRun) {
        setTimeout(async () => {
          await this.getClaimHistory();
        }, 3 * 1000);
      }
    },
    openPopup(pop) {
      this.popups[pop] = true;
    },
    closePopup(pop) {
      this.popups[pop] = false;
    },
    closeAllPopup() {
      this.closePopup("inputCoupon");
      this.closePopup("landResult");      
      this.closePopup("claimReward");
    },
     claimRewardPop: async function() {
      let ret = await axios.post(`${config.api.game_url}/land/claim/token/info`, {
        publicKey: this.myAddress
      });

      if (ret.data.result) {
        this.claim.amount = ret.data.totalReward;
        this.claim.fee = ret.data.fee;
        this.claim.net = ret.data.finalReward;
        this.openPopup('claimReward');
      }
      else {
        alert(this.$t('alert_insufficient_reward', [ret.data.err.fee]));
      }
    },
    claimRewardDAI: async function() {
      let ret = await axios.post(`${config.api.game_url}/land/claim/token/all`, {
        publicKey: this.myAddress,
        fee:this.claim.fee
      });
      if (ret.data.result) {
        alert(this.$t('info_claim_reward_queue'));
        this.closePopup('claimReward');
      }
      else {
        alert('Error!')
        this.closePopup('claimReward');
      }
    },
    inputCoupon: async function() {
      if (this.myAddress == null || this.myAddress == '') {
        return;
      }
      let ret = await axios.post(`${config.api.nft_url}/coupon/input`, {
        address: this.myAddress,
        coupon: this.coupon
      });
      this.closePopup('inputCoupon');
      if (!ret.data.result) {
        alert(this.$t(`alert_${ret.data.err.code}`));
        return;
      }
      
      this.resultLandId = ret.data.landId;
      this.openPopup('landResult');
    }
  },
  watch: {
    "$store.state.account.wallet": async function(val) {
        if (this.$store.state.account.wallet == null) {
          this.myAddress = '';
        }
        else {
          this.myAddress = this.$store.state.account.wallet.address;
        }
        if (this.$route.params.tab == null) {
        await this.getMyLands();
        await this.getUnclaimedRewards();
      }    
      else {
        this.selectTab(parseInt(this.$route.params.tab));
      }
    },
    "$route.params.tab": function(tab) {
      this.selectTab(parseInt(tab));
    }
  },
  computed: {
    myRefURL() {
      return `${config.web.url}?ref=${this.$store.state.account.landLordInfo.myRef}`;
    },
    myRefBonus() {
      return this.$store.state.account.landLordInfo.numRefBonus;
    },
    myBalance() {
      if (this.$store.state.account.wallet == null) {
        return 0;
      }
      return this.$store.state.account.wallet.balance;
    }
  },
  async mounted() {
if (this.$store.state.account.wallet == null) {
        this.myAddress = '';
      }
      else {
        this.myAddress = this.$store.state.account.wallet.address;
      }

    if (this.$route.params.tab == null) {
      await this.getMyLands();
    }    
    else {
      this.selectTab(parseInt(this.$route.params.tab));
    }
  },
  data: function() {
    return {
      claim: {
        amount: 0,
        fee: 1,
        net: 0
      },
      unclaimed: 0,
      myAddress: '',
      resultLandId: 100001,
      coupon: '',
      popups: {
        inputCoupon: false,
        landResult: false,
        claimReward: false
      },
      presaleHistory: [],
      claimHistory: [],
      myLandIds: [],
      tabIdx: 0,
      tabs: [
        {
          name: "account_myland"
        },
        {
          name: "account_claimhistory"
        },
        {
          name: "account_presalehistory"
        },
        // {
        //   name: "account_message"
        // },
        {
          name: "account_setting"
        }
      ]
    };
  }
};
</script>
<style>
.tab_active {
  color: #ff9600 !important;
}
.tab_inactive {
  color: #787878 !important;
  cursor: pointer;
}
.scrollbox {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.scrollbox::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
.ellipsis {
  text-overflow:ellipsis;
  white-space:nowrap;
  word-wrap:normal;
  width:100px;
  overflow:hidden;
  display: inline-block;
}
</style>
